import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff6d366c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-lg-row flex-column result-buttons column-row-gap-10" }
const _hoisted_2 = { class: "result-buttons__button-group flex" }
const _hoisted_3 = ["data-cy-id"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_5 = { class: "result-buttons__button-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_7 = { class: "container px-0 py-6" }
const _hoisted_8 = { "data-cy": "select-forecast-main-header" }
const _hoisted_9 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  ref: "formErrorsAlert",
  role: "alert"
}
const _hoisted_10 = { class: "alert-body" }
const _hoisted_11 = { class: "alert-heading" }
const _hoisted_12 = { class: "alert-text" }
const _hoisted_13 = ["data-cy"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { "aria-describedby": "input-choose-forecastname" }, null, -1))
const _hoisted_16 = {
  class: "row",
  "data-cy": "load-forecast-wrapper-div"
}
const _hoisted_17 = {
  class: "col-md-3",
  id: "choose-forecastname-div"
}
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  id: "forecast-select-label",
  class: "form-label",
  for: "input-choose-forecastname"
}
const _hoisted_20 = { class: "ml-2" }
const _hoisted_21 = ["data-error"]
const _hoisted_22 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_23 = ["value"]
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col-md-2 form-button" }
const _hoisted_26 = {
  id: "submit-button-forecast",
  type: "submit",
  class: "button button-primary adjust-button-size"
}
const _hoisted_27 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  ref: "formErrorsAlert",
  role: "alert"
}
const _hoisted_28 = { class: "alert-body" }
const _hoisted_29 = { class: "alert-heading" }
const _hoisted_30 = { class: "alert-text" }
const _hoisted_31 = ["data-cy"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "d-print-pagebreak" }
const _hoisted_34 = {
  class: "row",
  "data-cy": "scope-1-2-input-wrapper"
}
const _hoisted_35 = { class: "col-md-5" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = {
  class: "form-label",
  for: "input-type-method-scope12"
}
const _hoisted_38 = { class: "ml-2" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["value"]
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  class: "col-md-2",
  id: "choose-scope12-year-div"
}
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = {
  class: "form-label",
  for: "input-choose-scope12-year"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = ["value"]
const _hoisted_48 = {
  class: "col-md-2",
  id: "scope12-target-pct-div"
}
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = {
  class: "form-label",
  for: "input-scope12-target-pct"
}
const _hoisted_51 = { class: "form-input-wrapper form-input-wrapper--suffix" }
const _hoisted_52 = ["disabled", "data-error", "pattern"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-input-suffix",
  "aria-hidden": "true"
}, "%", -1))
const _hoisted_54 = { class: "col-md-2 form-button" }
const _hoisted_55 = ["disabled", "name"]
const _hoisted_56 = {
  key: 0,
  id: "reduction-target-scope-12-section"
}
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-md-12" }
const _hoisted_59 = { class: "bg-alternative-green p-405 margin-bot-30" }
const _hoisted_60 = {
  key: 0,
  "data-cy-id": "forecast.reduction-target.scope12.infotext.improve"
}
const _hoisted_61 = {
  key: 1,
  "data-cy-id": "forecast.reduction-target.scope12.infotext.success"
}
const _hoisted_62 = { "data-cy-id": "forecast.reduction-target.scope12.infotext.background" }
const _hoisted_63 = { class: "row d-print-pagebreak" }
const _hoisted_64 = { class: "col-12" }
const _hoisted_65 = { class: "py-1" }
const _hoisted_66 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  ref: "formErrorsAlert",
  role: "alert"
}
const _hoisted_67 = { class: "alert-body" }
const _hoisted_68 = { class: "alert-heading" }
const _hoisted_69 = { class: "alert-text" }
const _hoisted_70 = ["data-cy"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  "aria-describedby": "forecast.reduction-target.scope3.sub-title",
  class: "sr-only"
}
const _hoisted_73 = {
  class: "row",
  "data-cy": "scope-3-reduction-input-wrapper"
}
const _hoisted_74 = { class: "col-md-5" }
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = {
  class: "form-label",
  for: "input-type-method-scope3"
}
const _hoisted_77 = { class: "ml-2" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = ["value"]
const _hoisted_80 = ["value"]
const _hoisted_81 = {
  class: "col-md-2",
  id: "choose-scope3-div"
}
const _hoisted_82 = { class: "form-group" }
const _hoisted_83 = {
  class: "form-label",
  for: "input-choose-scope3-year"
}
const _hoisted_84 = ["disabled"]
const _hoisted_85 = { key: 0 }
const _hoisted_86 = ["value"]
const _hoisted_87 = {
  class: "col-md-2",
  id: "scope3-target-pct-div"
}
const _hoisted_88 = { class: "form-group" }
const _hoisted_89 = {
  class: "form-label",
  for: "input-scope3-target-pct"
}
const _hoisted_90 = { class: "form-input-wrapper form-input-wrapper--suffix" }
const _hoisted_91 = ["disabled", "data-error", "pattern"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-input-suffix",
  "aria-hidden": "true"
}, "%", -1))
const _hoisted_93 = { class: "col-md-2 form-button" }
const _hoisted_94 = ["disabled", "name"]
const _hoisted_95 = {
  key: 1,
  id: "reduction-target-scope3-section"
}
const _hoisted_96 = {
  class: "row",
  "data-cy": "scope3-reduction-column-chart"
}
const _hoisted_97 = { class: "col-md-12" }
const _hoisted_98 = {
  key: 0,
  class: "bg-alternative-green p-405 margin-bot-30",
  "data-cy-id": "forecast.reduction-target.scope3.infotext.improve"
}
const _hoisted_99 = {
  key: 1,
  class: "bg-alternative-green p-405 margin-bot-30",
  "data-cy-id": "forecast.reduction-target.scope3.infotext.success"
}
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col-md-12" }
const _hoisted_103 = { class: "form-group" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "multiselect-scope3-categories",
  class: "form-label",
  id: "multiselect-scope3-categories-label"
}, "Kategorier", -1))
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "col-md-7" }
const _hoisted_107 = { class: "col-md-4 form-button" }
const _hoisted_108 = {
  class: "ml-2",
  style: {"padding-left":"2px"}
}
const _hoisted_109 = {
  key: 2,
  class: "bg-alternative-green p-405 margin-bot-30",
  "data-cy-id": "forecast.reduction-target.scope3.cat3"
}
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-md-8 col-sm-12" }
const _hoisted_112 = { "data-cy-id": "forecast.reduction-target.scope3.infotext.background" }
const _hoisted_113 = { class: "col-md-4 col-sm-12" }
const _hoisted_114 = {
  key: 2,
  id: "main-header-scope3-section"
}
const _hoisted_115 = {
  id: "main-header-scope3-categories",
  class: "d-print-none"
}
const _hoisted_116 = { class: "row d-print-pagebreak" }
const _hoisted_117 = { class: "col-md-12" }
const _hoisted_118 = { class: "d-print-only" }
const _hoisted_119 = { class: "row" }
const _hoisted_120 = { class: "col-md-12" }
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "multiselect-scope3-categories2",
  class: "form-label",
  id: "multiselect-scope3-categories-label2"
}, "Kategorier", -1))
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "col-md-7" }
const _hoisted_125 = { class: "col-md-4 form-button" }
const _hoisted_126 = {
  class: "ml-2",
  style: {"padding-left":"2px"}
}
const _hoisted_127 = {
  key: 0,
  class: "bg-alternative-green p-405 margin-bot-30",
  "data-cy-id": "forecast.reduction-target.scope3.cat3-2"
}
const _hoisted_128 = { id: "reduction-target-net-zero-section" }
const _hoisted_129 = {
  id: "main-header-net-zero",
  class: "d-print-none"
}
const _hoisted_130 = { class: "row d-print-pagebreak" }
const _hoisted_131 = { class: "col-md-8" }
const _hoisted_132 = { class: "d-print-only" }
const _hoisted_133 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  ref: "formErrorsAlert",
  role: "alert"
}
const _hoisted_134 = { class: "alert-body" }
const _hoisted_135 = { class: "alert-heading" }
const _hoisted_136 = { class: "alert-text" }
const _hoisted_137 = ["data-cy"]
const _hoisted_138 = ["onClick"]
const _hoisted_139 = {
  "aria-describedby": "main-header-net-zero",
  class: "sr-only"
}
const _hoisted_140 = {
  class: "row",
  "data-cy": "net-zero-reduction-input-wrapper"
}
const _hoisted_141 = { class: "col-md-4 col-sm-6" }
const _hoisted_142 = { class: "form-group" }
const _hoisted_143 = {
  class: "form-label",
  for: "input-type-method-netzero"
}
const _hoisted_144 = { class: "ml-2" }
const _hoisted_145 = ["value"]
const _hoisted_146 = {
  class: "col-md-2 col-sm-6",
  id: "choose-net-zero-div"
}
const _hoisted_147 = { class: "form-group" }
const _hoisted_148 = {
  class: "form-label",
  for: "input-choose-net-zero-year"
}
const _hoisted_149 = ["disabled", "data-error"]
const _hoisted_150 = { key: 0 }
const _hoisted_151 = ["value"]
const _hoisted_152 = {
  class: "col-md-3 col-sm-6",
  id: "netzero-target-pct-div"
}
const _hoisted_153 = { class: "form-group" }
const _hoisted_154 = {
  class: "form-label",
  for: "input-net-zero-target-pct"
}
const _hoisted_155 = { class: "form-input-wrapper form-input-wrapper--suffix" }
const _hoisted_156 = ["disabled", "data-error", "pattern"]
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-input-suffix",
  "aria-hidden": "true"
}, "%", -1))
const _hoisted_158 = { class: "col-md-3 col-sm-6 form-button" }
const _hoisted_159 = ["disabled", "name"]
const _hoisted_160 = { key: 1 }
const _hoisted_161 = { key: 2 }
const _hoisted_162 = { class: "row d-print-none" }
const _hoisted_163 = { class: "col-md-6 d-print-block" }
const _hoisted_164 = {
  class: "netzero-label",
  style: {"width":"50%","margin":"auto"}
}
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, null, -1))
const _hoisted_166 = { class: "col-md-4 d-print-block" }
const _hoisted_167 = { class: "netzero-label" }
const _hoisted_168 = { class: "row d-print-only" }
const _hoisted_169 = { class: "col-md-12" }
const _hoisted_170 = {
  class: "row d-print-none",
  id: "reduction-target-net-zero-result-section",
  style: {"display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_171 = { class: "col-md-6" }
const _hoisted_172 = { class: "col-md-2 netzero" }
const _hoisted_173 = { class: "line-container" }
const _hoisted_174 = { class: "text" }
const _hoisted_175 = { class: "netzero-percentage" }
const _hoisted_176 = { class: "font-weight-bold-no-margin-top" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_178 = {
  class: "col-md-4 netzerocompare",
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_179 = { class: "row d-print-only" }
const _hoisted_180 = { class: "row d-print-only" }
const _hoisted_181 = { class: "line-container d-print-block" }
const _hoisted_182 = { class: "text" }
const _hoisted_183 = { class: "netzero-percentage" }
const _hoisted_184 = { class: "font-weight-bold-no-margin-top" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_186 = {
  class: "col-md-4",
  id: "net-zero-reduction-good-to-know"
}
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#arrow-left" })
], -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#arrow-left" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_AccordionComponent = _resolveComponent("AccordionComponent")!
  const _component_ForecastColumnChart = _resolveComponent("ForecastColumnChart")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Scope3CategoryReductionChart = _resolveComponent("Scope3CategoryReductionChart")!
  const _component_NetZeroPieChart = _resolveComponent("NetZeroPieChart")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, null, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.title" })
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_RichText, { "text-key": "forecast.reduction-target.header-text" })
        ])
      ]),
      secondColumn: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              id: "result-export-excel-link",
              class: "button button-secondary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)), ["prevent"])),
              "data-cy-id": 'klimakompasset-resultat-' + _ctx.selectedForecastId
            }, [
              _hoisted_4,
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.button.download" })
            ], 8, _hoisted_3),
            _createVNode(_component_Tooltip, {
              style: `vertical-align: middle;`,
              textKey: 'forecast.download-excel-tooltip',
              size: "lg"
            }, null, 8, ["textKey"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "button button-secondary flex-grow-equally",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDownloadPdf && _ctx.handleDownloadPdf(...args)), ["prevent"]))
            }, [
              _hoisted_6,
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.button.pdf" })
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("section", null, [
        _createVNode(_component_AccordionComponent, {
          "accordion-list": _ctx.getAccordions("forecast.reduction-target")
        }, null, 8, ["accordion-list"])
      ]),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("h2", null, [
          _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.select-forecast.sub-title" })
        ]),
        _createVNode(_component_RichText, { "text-key": "forecast.reduction-target.select-forecast.sub-header-text" })
      ]),
      _createElementVNode("section", null, [
        (_ctx.formValidation.formErrors.size)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, [
                  _createVNode(_component_SimpleText, { "text-key": "generic.input.error.title" })
                ]),
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidation.formErrors, ([key, value]) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: key,
                      "data-cy": 'error_' + key
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _withModifiers(($event: any) => (_ctx.focusInput(key)), ["prevent"]),
                        style: {"text-decoration":"none"}
                      }, _toDisplayString(value), 9, _hoisted_14)
                    ], 8, _hoisted_13))
                  }), 128))
                ])
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("form", {
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.formValidation.clearValidField && _ctx.formValidation.clearValidField(...args))),
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFormForecast && _ctx.submitFormForecast(...args)), ["prevent"])),
        onInvalidCapture: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.formValidation.handleFormValidity($event, false)), ["prevent"]))
      }, [
        _createElementVNode("fieldset", null, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.field.choose-forecast.name" })
                ]),
                _createElementVNode("span", _hoisted_20, [
                  _createVNode(_component_Tooltip, { "text-key": 'forecast.calculate-forecast.field.choose-forecast.tooltip' }, null, 8, ["text-key"])
                ]),
                (!_ctx.editExistingForecast)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      required: "",
                      class: "form-select",
                      name: "options",
                      id: "input-choose-forecastname",
                      "data-error": _ctx.chooseForecastError,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedForecastId) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_22, [
                        _createVNode(_component_SimpleText, { "text-key": "generic.input.dropdown.option-select.name" })
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedForecasts, (forecast) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: forecast.name,
                          value: forecast.forecastId
                        }, _toDisplayString(forecast.name), 9, _hoisted_23))
                      }), 128))
                    ], 8, _hoisted_21)), [
                      [_vModelSelect, _ctx.selectedForecastId]
                    ])
                  : (_openBlock(), _createElementBlock("input", {
                      key: 1,
                      class: "form-input",
                      type: "text",
                      value: _ctx.forecastName,
                      readonly: "",
                      "aria-readonly": "true",
                      "aria-labelledby": "forecast-select-label"
                    }, null, 8, _hoisted_24))
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", _hoisted_26, _toDisplayString(_ctx.getContentfulString('forecast.reduction-target.button-forecast.submit.name')), 1)
            ])
          ])
        ])
      ], 32),
      _createElementVNode("section", null, [
        (_ctx.formValidationScope12.formErrors.size)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("p", _hoisted_29, [
                  _createVNode(_component_SimpleText, { "text-key": "generic.input.error.title" })
                ]),
                _createElementVNode("ul", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidationScope12.formErrors, ([key, value]) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: key,
                      "data-cy": 'error_' + key
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _withModifiers(($event: any) => (_ctx.focusInput(key)), ["prevent"]),
                        style: {"text-decoration":"none"}
                      }, _toDisplayString(value), 9, _hoisted_32)
                    ], 8, _hoisted_31))
                  }), 128))
                ])
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("form", {
        onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.formValidationScope12.clearValidField && _ctx.formValidationScope12.clearValidField(...args))),
        onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFormScope12 && _ctx.submitFormScope12(...args)), ["prevent"])),
        onInvalidCapture: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.formValidationScope12.handleFormValidity($event, false)), ["prevent"]))
      }, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("legend", null, [
            _createElementVNode("h2", _hoisted_33, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.scope12.sub-title" })
            ])
          ]),
          _createElementVNode("span", null, [
            _createVNode(_component_RichText, { "text-key": "forecast.reduction-target.scope12.sub-header-text" })
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-target-method.name" })
                ]),
                _createElementVNode("span", _hoisted_38, [
                  _createVNode(_component_Tooltip, { "text-key": 'forecast.calculate-forecast.field.reduction-target-method.tooltip.scope12' }, null, 8, ["text-key"])
                ]),
                _withDirectives(_createElementVNode("select", {
                  disabled: _ctx.scope12InputDisabled,
                  required: "",
                  class: "form-select",
                  name: "options",
                  id: "input-type-method-scope12",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.typeMethodScope12) = $event))
                }, [
                  _createElementVNode("option", {
                    value: _ctx.enumManual,
                    selected: ""
                  }, [
                    _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.method.option.manual.name" })
                  ], 8, _hoisted_40),
                  _createElementVNode("option", { value: _ctx.enumSbti }, [
                    _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.method.option.sbti.name" })
                  ], 8, _hoisted_41)
                ], 8, _hoisted_39), [
                  [_vModelSelect, _ctx.typeMethodScope12]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", _hoisted_44, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-target-year.name" })
                ]),
                _withDirectives(_createElementVNode("select", {
                  disabled: _ctx.scope12InputDisabled || _ctx.method12IsSBTi,
                  required: "",
                  class: "form-select",
                  name: "options",
                  id: "input-choose-scope12-year",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedScope12Year) = $event))
                }, [
                  (_ctx.scope12InputDisabled)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_46, _toDisplayString(_ctx.getContentfulString('forecast.reduction-target.choose-year.text')), 1))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([..._ctx.possibleScope12Years.sort((a, b) => a - b)], (year) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: year,
                          value: year
                        }, _toDisplayString(year), 9, _hoisted_47))
                      }), 128))
                ], 8, _hoisted_45), [
                  [_vModelSelect, _ctx.selectedScope12Year]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", _hoisted_50, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-taget-pct.name" })
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: _ctx.possibleScope12Years.length === 0 || _ctx.method12IsSBTi,
                    onKeydown: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateLocalizedNumberInput($event, 'DECIMAL'))),
                    onFocus: _cache[9] || (_cache[9] = ($event: any) => ($event.target.select())),
                    onFocusout: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.validateScopeTargetPctInputs && _ctx.validateScopeTargetPctInputs(...args))),
                    id: "input-scope12-target-pct",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.scope12TargetPctWrap) = $event)),
                    "data-error": _ctx.scope12TargetPctError,
                    class: "form-input",
                    name: "input-scope12-target-pct",
                    type: "tel",
                    pattern: _ctx.findRegexPattern('regex.validation.nummeric.range.0-100.max-1-decimal'),
                    size: "9",
                    required: ""
                  }, null, 40, _hoisted_52), [
                    [_vModelText, _ctx.scope12TargetPctWrap]
                  ]),
                  _hoisted_53
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                disabled: _ctx.possibleScope12Years.length === 0,
                id: "submit-button-forecast12",
                class: "button button-primary adjust-button-size",
                type: "submit",
                name: _ctx.getContentfulString('forecast.reduction-target.button-scope12.submit.name')
              }, [
                _createVNode(_component_SimpleText, { "text-key": 'forecast.reduction-target.button-scope12.submit.name' }, null, 8, ["text-key"])
              ], 8, _hoisted_55)
            ])
          ])
        ])
      ], 32),
      (_ctx.scope12Completed)
        ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  (_ctx.isScope12Improve)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_60, null, 512)), [
                        [_directive_dompurify_html, _ctx.scope12InfoTextImprove]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_61, null, 512)), [
                        [_directive_dompurify_html, _ctx.scope12InfoTextSuccess]
                      ])
                ]),
                (_ctx.scope12ChartCalculations && _ctx.scope12ChartTarget)
                  ? (_openBlock(), _createBlock(_component_ForecastColumnChart, {
                      key: 0,
                      ref: "scope12chart",
                      "raw-data": _ctx.scope12ChartCalculations,
                      "raw-data-reduction": _ctx.scope12ChartTarget,
                      settings: _ctx.scope12ChartSettings
                    }, null, 8, ["raw-data", "raw-data-reduction", "settings"]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_62, null, 512), [
                  [_directive_dompurify_html, _ctx.scope12InfoTextBackground]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("h2", null, [
            _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.scope3.sub-title" })
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_RichText, { "text-key": "forecast.reduction-target.scope3.sub-header-text" })
          ])
        ])
      ]),
      _createElementVNode("section", null, [
        (_ctx.formValidationScope3.formErrors.size)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("p", _hoisted_68, [
                  _createVNode(_component_SimpleText, { "text-key": "generic.input.error.title" })
                ]),
                _createElementVNode("ul", _hoisted_69, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidationScope3.formErrors, ([key, value]) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: key,
                      "data-cy": 'error_' + key
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _withModifiers(($event: any) => (_ctx.focusInput(key)), ["prevent"]),
                        style: {"text-decoration":"none"}
                      }, _toDisplayString(value), 9, _hoisted_71)
                    ], 8, _hoisted_70))
                  }), 128))
                ])
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("form", {
        onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.formValidationScope3.clearValidField && _ctx.formValidationScope3.clearValidField(...args))),
        onInvalidCapture: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.formValidationScope3.handleFormValidity($event, false)), ["prevent"])),
        onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFormScope3 && _ctx.submitFormScope3(...args)), ["prevent"]))
      }, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("legend", _hoisted_72, [
            _createTextVNode(" scope-3 "),
            _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.fieldset.legend.scope3" })
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("label", _hoisted_76, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-target-method.name" })
                ]),
                _createElementVNode("span", _hoisted_77, [
                  _createVNode(_component_Tooltip, { "text-key": 'forecast.calculate-forecast.field.reduction-target-method.tooltip.scope3' }, null, 8, ["text-key"])
                ]),
                _withDirectives(_createElementVNode("select", {
                  required: "",
                  class: "form-select",
                  name: "options",
                  id: "input-type-method-scope3",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.typeMethodScope3) = $event)),
                  disabled: _ctx.scope3InputDisabled
                }, [
                  _createElementVNode("option", {
                    value: _ctx.enumManual,
                    selected: ""
                  }, [
                    _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.method.option.manual.name" })
                  ], 8, _hoisted_79),
                  _createElementVNode("option", { value: _ctx.enumSbti }, [
                    _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.method.option.sbti.name" })
                  ], 8, _hoisted_80)
                ], 8, _hoisted_78), [
                  [_vModelSelect, _ctx.typeMethodScope3]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("label", _hoisted_83, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-target-year.name" })
                ]),
                _withDirectives(_createElementVNode("select", {
                  disabled: _ctx.scope3InputDisabled || _ctx.method3IsSBTi,
                  required: "",
                  class: "form-select",
                  name: "options",
                  id: "input-choose-scope3-year",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedScope3Year) = $event))
                }, [
                  (_ctx.scope3InputDisabled)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_85, _toDisplayString(_ctx.getContentfulString('forecast.reduction-target.choose-year.text')), 1))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([..._ctx.possibleScope3Years.sort((a, b) => a - b)], (year) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: year,
                          value: year
                        }, _toDisplayString(year), 9, _hoisted_86))
                      }), 128))
                ], 8, _hoisted_84), [
                  [_vModelSelect, _ctx.selectedScope3Year]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("label", _hoisted_89, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-taget-pct.name" })
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: _ctx.scope3InputDisabled || _ctx.method3IsSBTi,
                    onKeydown: _cache[17] || (_cache[17] = ($event: any) => (_ctx.validateLocalizedNumberInput($event, 'DECIMAL'))),
                    onFocus: _cache[18] || (_cache[18] = ($event: any) => ($event.target.select())),
                    onFocusout: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.validateScopeTargetPctInputs && _ctx.validateScopeTargetPctInputs(...args))),
                    id: "input-scope3-target-pct",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.scope3TargetPctWrap) = $event)),
                    "data-error": _ctx.scope3TargetPctError,
                    class: "form-input",
                    name: "input-scope3-target-pct",
                    pattern: _ctx.findRegexPattern('regex.validation.nummeric.range.0-100.max-1-decimal'),
                    size: "9",
                    required: ""
                  }, null, 40, _hoisted_91), [
                    [_vModelText, _ctx.scope3TargetPctWrap]
                  ]),
                  _hoisted_92
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("button", {
                disabled: _ctx.scope3InputDisabled,
                id: "submit-button-reduction",
                class: "button button-primary adjust-button-size",
                type: "submit",
                name: _ctx.getContentfulString('forecast.reduction-target.button-scope3.submit.name')
              }, [
                _createVNode(_component_SimpleText, { "text-key": 'forecast.reduction-target.button-scope3.submit.name' }, null, 8, ["text-key"])
              ], 8, _hoisted_94)
            ])
          ])
        ])
      ], 32),
      (_ctx.scope3Completed)
        ? (_openBlock(), _createElementBlock("section", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                (_ctx.isScope3Improve)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                      _withDirectives(_createElementVNode("span", null, null, 512), [
                        [_directive_dompurify_html, _ctx.scope3InfoTextImprove]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_99, [
                      _withDirectives(_createElementVNode("span", null, null, 512), [
                        [_directive_dompurify_html, _ctx.scope3InfoTextSuccess]
                      ])
                    ])),
                _createElementVNode("div", null, [
                  (_ctx.showScope3Categories)
                    ? (_openBlock(), _createElementBlock("form", _hoisted_100, [
                        _createElementVNode("fieldset", null, [
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("div", _hoisted_103, [
                                _hoisted_104,
                                _createElementVNode("div", _hoisted_105, [
                                  _createElementVNode("div", _hoisted_106, [
                                    _createVNode(_component_Multiselect, {
                                      id: "multiselect-scope3-categories",
                                      modelValue: _ctx.selectedCategories,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.selectedCategories) = $event)),
                                      mode: "tags",
                                      "close-on-select": false,
                                      hideSelected: false,
                                      canClear: false,
                                      groups: true,
                                      options: _ctx.multiselectOptions,
                                      "track-by": "categoryId",
                                      valueProp: "categoryId",
                                      label: "categoryPresentationName",
                                      ref: "forecast-category-select",
                                      class: "multiselect-calculation",
                                      aria: {'aria-labelledby': 'multiselect-scope3-categories-label', 'aria-placeholder': null, 'aria-multiselectable': null},
                                      placeholder: _ctx.getContentfulString('forecast.filter.placeholder.all-Categories-selected'),
                                      style: {"width":"100%"}
                                    }, null, 8, ["modelValue", "options", "placeholder"])
                                  ]),
                                  _createElementVNode("div", _hoisted_107, [
                                    _createElementVNode("button", {
                                      id: "submit-button-show-forecast",
                                      class: "button button-primary",
                                      onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.showAndSaveForecast()), ["prevent"]))
                                    }, "Vis og gem fremskrivning"),
                                    _createElementVNode("span", _hoisted_108, [
                                      _createVNode(_component_Tooltip, { "text-key": "xxxx" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.scope3Completed && _ctx.showScope3Categories)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.scope3CategoryInfoTextOne), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.scope3ChartCalculations && _ctx.scope3ChartTarget)
                  ? (_openBlock(), _createBlock(_component_ForecastColumnChart, {
                      key: 3,
                      ref: "scope3chart",
                      "raw-data": _ctx.scope3ChartCalculations,
                      "raw-data-reduction": _ctx.scope3ChartTarget,
                      settings: _ctx.scope3ChartSettings,
                      "is-maec": _ctx.method3IsSBTi
                    }, null, 8, ["raw-data", "raw-data-reduction", "settings", "is-maec"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("div", _hoisted_111, [
                _withDirectives(_createElementVNode("div", _hoisted_112, null, 512), [
                  [_directive_dompurify_html, _ctx.scope3InfoTextBackground]
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("p", null, [
                  _createElementVNode("b", null, [
                    _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.scope3.piechart.title" })
                  ])
                ]),
                _createVNode(_component_apexchart, {
                  ref: "scope3Pie",
                  type: "pie",
                  width: "380",
                  options: _ctx.scope3PieOptions,
                  series: _ctx.scope3PieSeries
                }, null, 8, ["options", "series"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showScope3Categories)
        ? (_openBlock(), _createElementBlock("section", _hoisted_114, [
            _createElementVNode("h3", _hoisted_115, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.scope3-categories.sub-title" })
            ]),
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("div", _hoisted_117, [
                _createElementVNode("h3", _hoisted_118, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.scope3-categories.sub-title" })
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.scope3-categories.main-description" })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("form", null, [
                    _createElementVNode("fieldset", null, [
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _createElementVNode("div", _hoisted_121, [
                            _hoisted_122,
                            _createElementVNode("div", _hoisted_123, [
                              _createElementVNode("div", _hoisted_124, [
                                _createVNode(_component_Multiselect, {
                                  id: "multiselect-scope3-categories2",
                                  modelValue: _ctx.selectedCategories,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectedCategories) = $event)),
                                  mode: "tags",
                                  "close-on-select": false,
                                  hideSelected: false,
                                  canClear: false,
                                  groups: true,
                                  "group-hide-empty": true,
                                  options: _ctx.multiselectOptions,
                                  "track-by": "categoryId",
                                  valueProp: "categoryId",
                                  label: "categoryPresentationName",
                                  ref: "forecast-category-select",
                                  class: "multiselect-calculation",
                                  aria: {'aria-labelledby': 'multiselect-scope3-categories-label2'},
                                  placeholder: _ctx.getContentfulString('forecast.filter.placeholder.all-Categories-selected'),
                                  style: {"width":"100%"}
                                }, null, 8, ["modelValue", "options", "placeholder"])
                              ]),
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("button", {
                                  id: "submit-button-show-forecast",
                                  class: "button button-primary",
                                  onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.showAndSaveForecast()), ["prevent"]))
                                }, "Vis og gem fremskrivning"),
                                _createElementVNode("span", _hoisted_126, [
                                  _createVNode(_component_Tooltip, { "text-key": "xxxx" })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                (_ctx.scope3Completed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.scope3CategoryInfoTextTwo), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.scope3Completed)
                  ? (_openBlock(), _createBlock(_component_Scope3CategoryReductionChart, {
                      key: 1,
                      mode: _ctx.mode,
                      "possible-downstream-categories": _ctx.possibleDownstreamCategories,
                      "possible-upstream-categories": _ctx.possibleUpstreamCategories,
                      ref: "scope3CategoryChartRef"
                    }, null, 8, ["mode", "possible-downstream-categories", "possible-upstream-categories"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_128, [
        _createElementVNode("h2", _hoisted_129, [
          _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.netzero.sub-title" })
        ]),
        _createElementVNode("div", _hoisted_130, [
          _createElementVNode("div", _hoisted_131, [
            _createElementVNode("h2", _hoisted_132, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.netzero.sub-title" })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.netzero.main-description" })
            ]),
            (_ctx.formValidationNetzero.formErrors.size)
              ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("p", _hoisted_135, [
                      _createVNode(_component_SimpleText, { "text-key": "generic.input.error.title" })
                    ]),
                    _createElementVNode("ul", _hoisted_136, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidationNetzero.formErrors, ([key, value]) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: key,
                          "data-cy": 'error_' + key
                        }, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _withModifiers(($event: any) => (_ctx.focusInput(key)), ["prevent"]),
                            style: {"text-decoration":"none"}
                          }, _toDisplayString(value), 9, _hoisted_138)
                        ], 8, _hoisted_137))
                      }), 128))
                    ])
                  ])
                ], 512))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              ref: "formGroup",
              onChange: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.formValidationNetzero.clearValidField && _ctx.formValidationNetzero.clearValidField(...args))),
              onInvalidCapture: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (_ctx.formValidationNetzero.handleFormValidity($event, false)), ["prevent"])),
              onSubmit: _cache[36] || (_cache[36] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFormNetzero && _ctx.submitFormNetzero(...args)), ["prevent"]))
            }, [
              _createElementVNode("fieldset", null, [
                _createElementVNode("legend", _hoisted_139, [
                  _createTextVNode(" net-zero "),
                  _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.fieldset.legend" })
                ]),
                _createElementVNode("div", _hoisted_140, [
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _createElementVNode("label", _hoisted_143, [
                        _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-target-method.name" })
                      ]),
                      _createElementVNode("span", _hoisted_144, [
                        _createVNode(_component_Tooltip, { "text-key": 'forecast.calculate-forecast.field.reduction-target-method.tooltip.netzero' }, null, 8, ["text-key"])
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        disabled: "",
                        required: "",
                        class: "form-select",
                        style: {"margin-top":"7px"},
                        name: "options",
                        id: "input-type-method-netzero",
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.typeMethodNetzero) = $event))
                      }, [
                        _createElementVNode("option", {
                          value: _ctx.enumManual,
                          selected: ""
                        }, [
                          _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.method.option.manual.name" })
                        ], 8, _hoisted_145)
                      ], 512), [
                        [_vModelSelect, _ctx.typeMethodNetzero]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_146, [
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("label", _hoisted_148, [
                        _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-target-year.name" })
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        required: "",
                        disabled: _ctx.netzeroInputDisabled,
                        "data-error": _ctx.netzeroYearError,
                        class: "form-select",
                        name: "options",
                        id: "input-choose-net-zero-year",
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.selectedNetzeroYear) = $event))
                      }, [
                        (_ctx.netzeroInputDisabled)
                          ? (_openBlock(), _createElementBlock("option", _hoisted_150, _toDisplayString(_ctx.getContentfulString('forecast.reduction-target.choose-year.text')), 1))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([..._ctx.possibleNetzeroYears.sort((a, b) => a - b)], (year) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: year,
                                value: year
                              }, _toDisplayString(year), 9, _hoisted_151))
                            }), 128))
                      ], 8, _hoisted_149), [
                        [_vModelSelect, _ctx.selectedNetzeroYear]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("label", _hoisted_154, [
                        _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.field.reduction-taget-pct.name" })
                      ]),
                      _createElementVNode("div", _hoisted_155, [
                        _withDirectives(_createElementVNode("input", {
                          disabled: _ctx.netzeroInputDisabled,
                          onKeydown: _cache[30] || (_cache[30] = ($event: any) => (_ctx.validateLocalizedNumberInput($event, 'DECIMAL'))),
                          onFocus: _cache[31] || (_cache[31] = ($event: any) => ($event.target.select())),
                          onFocusout: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.validateScopeTargetPctInputs && _ctx.validateScopeTargetPctInputs(...args))),
                          id: "input-net-zero-target-pct",
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.netzeroTargetPct) = $event)),
                          "data-error": _ctx.netzeroTargetPctError,
                          class: "form-input",
                          name: "input-scope3-target-pct",
                          pattern: _ctx.findRegexPattern('regex.validation.nummeric.range.0-100.max-1-decimal'),
                          size: "9",
                          required: ""
                        }, null, 40, _hoisted_156), [
                          [_vModelText, _ctx.netzeroTargetPct]
                        ]),
                        _hoisted_157
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_158, [
                    _createElementVNode("button", {
                      disabled: _ctx.netzeroInputDisabled,
                      id: "submit-button-net-zero",
                      class: "button button-primary adjust-button-size",
                      name: _ctx.getContentfulString('forecast.reduction-target.button-netzero.submit.name'),
                      type: "submit"
                    }, [
                      _createVNode(_component_SimpleText, { "text-key": 'forecast.reduction-target.button-netzero.submit.name' }, null, 8, ["text-key"])
                    ], 8, _hoisted_159)
                  ])
                ])
              ])
            ], 544),
            (_ctx.scope3Categories)
              ? (_openBlock(), _createElementBlock("section", _hoisted_160))
              : _createCommentVNode("", true),
            (_ctx.netZeroCompleted)
              ? (_openBlock(), _createElementBlock("section", _hoisted_161, [
                  _createElementVNode("div", _hoisted_162, [
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.netzeroPiechartBasisTitle), 1),
                        _createElementVNode("h4", null, _toDisplayString(_ctx.netzeroPiechartBasisValue), 1)
                      ])
                    ]),
                    _hoisted_165,
                    _createElementVNode("div", _hoisted_166, [
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.netzeroPiechartTargetTitle), 1),
                        _createElementVNode("h4", null, _toDisplayString(_ctx.netzeroPiechartTargetValue), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.netzeroPiechartBasisTitle) + ": " + _toDisplayString(_ctx.netzeroPiechartBasisValue), 1),
                      _createElementVNode("h4", null, _toDisplayString(_ctx.netzeroPiechartTargetTitle) + ": " + _toDisplayString(_ctx.netzeroPiechartTargetValue), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_170, [
                    _createElementVNode("div", _hoisted_171, [
                      _createVNode(_component_apexchart, {
                        ref: "netzeroPie",
                        type: "pie",
                        options: _ctx.netZeroPieOptions,
                        series: _ctx.netzeroPieSeriesBasis
                      }, null, 8, ["options", "series"])
                    ]),
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", _hoisted_173, [
                        _createElementVNode("div", _hoisted_174, [
                          _createElementVNode("span", _hoisted_175, _toDisplayString(_ctx.prettyNetzeroTargetPct) + "% ", 1),
                          _createElementVNode("p", _hoisted_176, _toDisplayString(_ctx.netzeroLineTitle), 1)
                        ]),
                        _hoisted_177
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_178, [
                      _createVNode(_component_NetZeroPieChart, { adjustedWidth: _ctx.netzeroPieTargetSize }, null, 8, ["adjustedWidth"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_179, [
                    _createVNode(_component_apexchart, {
                      class: "d-print-inline-block",
                      ref: "netzeroPie",
                      width: "300px",
                      type: "pie",
                      options: _ctx.netzeroPieOptionsBasis,
                      series: _ctx.netzeroPieSeriesBasis
                    }, null, 8, ["options", "series"]),
                    _createVNode(_component_apexchart, {
                      class: "d-print-inline-block",
                      type: "pie",
                      width: _ctx.netzeroPieTargetSize/1.5,
                      options: _ctx.netzeroPieOptionsTarget,
                      series: _ctx.netzeroPieSeriesTarget
                    }, null, 8, ["width", "options", "series"])
                  ]),
                  _createElementVNode("div", _hoisted_180, [
                    _createElementVNode("div", _hoisted_181, [
                      _createElementVNode("div", _hoisted_182, [
                        _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.prettyNetzeroTargetPct) + "% ", 1),
                        _createElementVNode("p", _hoisted_184, _toDisplayString(_ctx.netzeroLineTitle), 1)
                      ]),
                      _hoisted_185
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_186, [
            _createVNode(_component_RichText, { "text-key": "forecast.reduction-target.netzero.good-to-know" })
          ])
        ])
      ]),
      _createElementVNode("section", null, [
        (_ctx.selectedForecastId)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.backToForecast())),
              class: "button button-primary"
            }, [
              _hoisted_187,
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.back" })
            ]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "button button-primary",
              to: "/forecast/forecast-overview"
            }, {
              default: _withCtx(() => [
                _hoisted_188,
                _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.back" })
              ]),
              _: 1
            }))
      ])
    ])
  ], 64))
}